import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=ebacaa10&scoped=true"
import script from "./Config.vue?vue&type=script&lang=js"
export * from "./Config.vue?vue&type=script&lang=js"
import style0 from "./Config.vue?vue&type=style&index=0&id=ebacaa10&prod&lang=scss"
import style1 from "./Config.vue?vue&type=style&index=1&id=ebacaa10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebacaa10",
  null
  
)

export default component.exports